module.exports = __webpack_public_path__ + "img/da-rain.cdf0cf5c.png";